import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { Providers } from 'domain/Providers';
import { theme } from 'view/themes/theme';
import 'view/themes/index.css';
import { Toaster } from 'sonner';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider theme={theme}>
    <Providers>
      <App />
      <Toaster expand visibleToasts={9} position="top-right" />
    </Providers>
  </ThemeProvider>
);
